import React from 'react';
import { inject, observer } from 'mobx-react';
import classNames from 'classnames';
import {
	AddressesStore,
	BookingDictionariesStore,
	NewBookingsStore,
	BookingCCStore,
	RootStore,
	PassengerDetailsStore,
} from 'AppClient/stores';
import { Fragment, CCDisplay } from 'components';
import { datetimeWithTimeZone, roundNumber } from 'utils/converters';
import { Icon } from 'components/antd';
import { VehicleIcon } from 'AppClient/components/VehicleIcon';
import { AddressesView } from 'AppClient/components/TripDetails/AddressesView';
import { ThemeContext } from 'app-themes';

import styles from './styles.module.scss';
import { StaticMap } from '../TripDetails/StaticMap';
import { isNil } from 'lodash-es';

interface Props {
	newBookingsStore: NewBookingsStore;
	bookingDictionariesStore: BookingDictionariesStore;
	addressesStore?: AddressesStore;
	bookingCCStore?: BookingCCStore;
	passengerDetailsStore?: PassengerDetailsStore;
	carTypeId?: number | string | null;
}

@inject(
	({
		newBookingsStore,
		bookingDictionariesStore,
		addressesStore,
		bookingCCStore,
		passengerDetailsStore,
	}: RootStore) => ({
		newBookingsStore,
		bookingDictionariesStore,
		addressesStore,
		bookingCCStore,
		passengerDetailsStore,
	})
)
@observer
export class NewBookingRegards extends React.Component<Props> {
	static contextType = ThemeContext;

	render() {
		const {
			bookedSummary,
			pricesRequestPayload,
			finalPickUpDateTime,
		} = this.props.newBookingsStore!;
		const { findCarById } = this.props.bookingDictionariesStore!;
		const { addressesArray } = this.props.addressesStore!;
		const { currentBookingCard } = this.props.bookingCCStore!;
		const { userInfo } = this.props.passengerDetailsStore!;
		const { carTypeId } = pricesRequestPayload;
		const theme = this.context;

		const carDetails = findCarById(carTypeId);
		if (!bookedSummary) {
			return null;
		}
		return (
			<div
				className={classNames(styles.regards, {
					[styles[`regards-${theme}`]]: theme !== '',
				})}
			>
				<div className={styles.regardsLogo} />
				<div>
					<h2>meet your driver</h2>
					<div className="modalBox modalBoxBooking">
						<StaticMap />
						<div className="modalBoxRow">
							<div className="modalBoxCol">
								<div className={classNames(styles.regardsBox, styles.dateTime)}>
									<Icon type="dateTimePicker" />
									<span className={styles.regardsUpComing}>
										{finalPickUpDateTime &&
											datetimeWithTimeZone(finalPickUpDateTime)}
									</span>
								</div>

								<div className={classNames(styles.regardsBox, styles.rout)}>
									<AddressesView addresses={addressesArray} />
								</div>
								{!isNil(userInfo) && userInfo.journeyNotes && (
									<div
										className={classNames(
											styles.regardsBox,
											styles.meetingPoint
										)}
									>
										<Icon type="info" />
										<span className={styles.meetingPointInfo}>
											<h6 className={styles.meetingPointTitle}>
												Meeting Point Information
											</h6>
											<span className={styles.meetingPointText}>
												{userInfo.journeyNotes}
											</span>
										</span>
									</div>
								)}
							</div>
						</div>
					</div>

					<div className="modalBox modalBoxBooking">
						<div className="modalBoxRow">
							<div className="modalBoxCol">
								<div className={classNames(styles.regardsBox, styles.provider)}>
									<span className={styles.regardsTransfer}>
										{bookedSummary.bookingPrice.serviceProviderName}
									</span>

									<span className={styles.regardsCost}>
										{bookedSummary.customerCurrencySymbol}{' '}
										{roundNumber(
											bookedSummary.bookingPrice.totalPriceInCustomerCurrency
										)}
									</span>
								</div>
								<div className={classNames(styles.regardsBox, styles.provider)}>
									<a
										className={styles.regardsPhone}
										href={`tel:${bookedSummary.bookingPrice.serviceProviderPhoneNumber}`}
									>
										{bookedSummary.bookingPrice.serviceProviderPhoneNumber}
									</a>

									<span className={styles.regardsDuration}>
										{bookedSummary.getFullTripEstimate}
									</span>
								</div>
							</div>
						</div>
					</div>

					<div className="modalBox modalBoxBooking">
						<div className="modalBoxRow">
							<div className="modalBoxCol">
								<Fragment>
									{currentBookingCard && (
										<div
											className={classNames(
												styles.regardsBox,
												styles.carType
											)}
										>
											<CCDisplay creditCard={currentBookingCard} />
										</div>
									)}
								</Fragment>

								<Fragment>
									{carDetails && (
										<div
											className={classNames(
												styles.regardsBox,
												styles.carType
											)}
										>
											<span>
												<VehicleIcon carTypeName={carDetails.carTypeName} />
												<span>
													{`${carDetails.carTypeName}, ${bookedSummary.numberOfPassengers} pass`}
												</span>
											</span>
										</div>
									)}
								</Fragment>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
